import React, { useState } from 'react'
import Modal from '@/v2/components/common/Modal'
import { useSnackbarContext } from '@/v2/contexts/SnackbarContext'
import { formatPhone } from '@/v2/utils/format'
import { toSnakeCase } from '@/v2/utils/format'
import { useUpdatePatient } from '@/v2/hooks/patient/usePatient'
import Form from './Form'
import validator from './validator'

const EditPatient = ({ patient, isOpen, onClose, onSuccess }) => {
  const [values, setValues] = useState({
    emergencyName: patient.emergencyName || '',
    emergencyRelationship: patient.emergencyRelationship || '',
    emergencyEmail: patient.emergencyEmail || '',
    emergencyPhoneNumber: formatPhone(patient.emergencyPhoneNumber),
  })
  const { updatePatient } = useUpdatePatient(patient.id)
  const [error, setError] = useState({})
  const { onOpenSnackbar } = useSnackbarContext()

  const handleEditPatient = async () => {
    // TODO: ask to migrate from snake case to camel case
    try {
      const { error, ...data } = await updatePatient({
        patient: toSnakeCase({
          id: patient.id,
          ...values,
        }),
      })

      if (error) {
        setError(toCamelCase(error))
      } else {
        onSuccess && onSuccess(data)
        onOpenSnackbar('Patient has been updated.', 'success')
        onClose()
      }
    } catch (error) {
      onOpenSnackbar('Something went wrong.', 'error')
    }
  }

  const handleSubmit = () => {
    const validErrors = validator(values)
    setError(validErrors || {})

    if (!validErrors) {
      handleEditPatient()
    }
  }

  return (
    <Modal
      isOpen={isOpen}
      title="Edit Patient"
      confirmLabel="Save"
      cancelLabel="Cancel"
      onConfirm={handleSubmit}
      onClose={onClose}
    >
      <Form
        values={values}
        error={error}
        onChange={value => setValues({ ...values, ...value })}
      />
    </Modal>
  )
}

export default EditPatient
